import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from './Media';
import { useTranslation } from 'react-i18next';
import { HiOutlineDocumentText } from "react-icons/hi";
import i18next from 'i18next';

const LeftBanner = () => {
  const { t } = useTranslation();

  // جلب قائمة العناوين من ملف الترجمة (مصفوفة)
  const titles = t("banner.titles", { returnObjects: true });

  // إذا كانت القائمة غير موجودة أو فارغة، استخدم القيم الافتراضية
  const words = Array.isArray(titles) && titles.length ? titles : [
    t("banner.titles.one"),
    t("banner.titles.tow"),
    t("banner.titles.three"),
    t("banner.titles.four")
  ];

  const [text] = useTypewriter({
    words: words,
    loop: true,
    typeSpeed: 40,      // يمكنك تعديل السرعة حسب الرغبة
    deleteSpeed: 20,
    delaySpeed: 2000,
  });

  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className="text-lg font-normal">{t("banner.welcomeMessage")}</h4>
        <h1 className="text-6xl font-bold text-white">
          {t("banner.greeting")} <span className="text-designColor capitalize">{t("banner.myName")}</span>
        </h1>
        <h2 className="text-4xl font-bold text-white h-[90px]"> {/* زيادة الارتفاع قليلاً لاستيعاب نصوص أطول */}
          {t("banner.workAs")} <span>{text}</span>
          <Cursor cursorBlinking="false" cursorStyle="|" cursorColor="#ff014f" />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
          {t("banner.description")}
        </p>
      </div>
      <Media />
      <div>
        <p className="text-base font-bodyFont leading-6 tracking-wide mb-4">
          {i18next.language === 'ar' ? "تحميل ملف السيرة الذاتية:" : "Download CV: "}
        </p>
        <a
          href="/CV/moayad ismail (3).pdf"
          download
          className="bannerIcon"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="bannerIcon">
            <HiOutlineDocumentText />
          </span>
        </a>
      </div>
    </div>
  );
}

export default LeftBanner;